import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/cn.js';

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;

export function DialogContent({ className, children, size = 'md', ...props }) {
  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
    '2xl': 'max-w-3xl',
    '3xl': 'max-w-5xl',
    full: 'max-w-[95vw]',
    fit: 'max-w-fit',
  };
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in" />
      <DialogPrimitive.Content
        className={cn(
          'fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-xl border border-slate-200 bg-white p-6 shadow-xl dark:bg-slate-900 dark:border-slate-800',
          size === 'fit' ? 'w-fit' : 'w-full',
          sizes[size],
          'max-h-[90vh] overflow-y-auto',
          className,
        )}
        {...props}
      >
        {children}
        <DialogPrimitive.Close className="absolute top-3 right-3 p-1 rounded text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800">
          <X className="h-4 w-4" />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}

export function DialogHeader({ className, children }) {
  return <div className={cn('mb-4', className)}>{children}</div>;
}
export function DialogTitle({ className, children }) {
  return (
    <DialogPrimitive.Title className={cn('text-lg font-semibold text-slate-900 dark:text-slate-100', className)}>
      {children}
    </DialogPrimitive.Title>
  );
}
export function DialogDescription({ className, children }) {
  return (
    <DialogPrimitive.Description className={cn('text-sm text-slate-500 dark:text-slate-400 mt-1', className)}>
      {children}
    </DialogPrimitive.Description>
  );
}
export function DialogFooter({ className, children }) {
  return <div className={cn('mt-6 flex justify-end gap-2', className)}>{children}</div>;
}
